import type { IconName } from '@customerio/pluma-icons';
import type { SearchResult } from '@/services/auth/types';
import { ACTION_TYPE_ICONS } from './constants';
import type { LocalCommand } from './local-commands';

// TODO there will likely be better icons/granularity to implement as we get design feedback
export function getIconNameFromSearchResult(result: SearchResult): IconName {
  switch (result.kind) {
    case 'campaign':
      return 'campaigns';
    case 'template':
      return 'layout';
    case 'segment':
      return 'segment';
    case 'action':
      // TODO unsure if the mock data is correct, if not we need to update the mapping
      return ACTION_TYPE_ICONS?.[`${result.other.action_type}_action`] ?? 'help';
    case 'navigation':
      return 'arrow-right';
    default:
      return 'search';
  }
}

export function getHeadingbyKind(kind: SearchResult['kind']) {
  switch (kind) {
    case 'campaign':
      return 'Campaigns';
    case 'template':
      return 'Templates';
    case 'segment':
      return 'Segments';
    case 'action':
      return 'Actions';
    case 'navigation':
      return 'Navigation';
    default:
      return 'Search';
  }
}

export function filterLocalCommands(commands: LocalCommand[], query: string): LocalCommand[] {
  if (query.length === 0) {
    return commands;
  }

  const lowerQuery = query.toLowerCase();
  return commands.filter((cmd) => {
    const searchText = [cmd.label, cmd.description, ...(cmd.keywords ?? [])].filter(Boolean).join(' ').toLowerCase();

    return searchText.includes(lowerQuery);
  });
}
